import dynamic from 'next/dynamic';

export { default as GroupedProductList } from './GroupedProductList/GroupedProductList';
export { default as MobilePreviewProductCard } from './MobilePreviewProductCard/MobilePreviewProductCard';
export { default as ProductBanner } from './ProductBanner/ProductBanner';
export { default as ProductCard } from './ProductCard/ProductCard';
export { default as ProductCardSkeleton } from './ProductCard/ProductCardSkeleton';
export { default as ProductCartCard } from './ProductCartCard/ProductCartCard';
export { default as ProductCartCardSkeleton } from './ProductCartCard/ProductCartCardSkeleton';
export { default as ProductCheckoutCard } from './ProductCheckoutCard/ProductCheckoutCard';
export { default as ProductDeleteToastBody } from './ProductDeleteToastBody/ProductDeleteToastBody';
export { default as ProductDeliveryComment } from './ProductDeliveryComment/ProductDeliveryComment';
export { default as ProductDetails } from './ProductDetails/ProductDetails';
export { default as ProductDetailsSkeleton } from './ProductDetails/ProductDetailsSkeleton';
export { default as ProductGiftCard } from './ProductGiftCard/ProductGiftCard';
export { default as ProductImage } from './ProductImage/ProductImage';
export { default as ProductLabel } from './ProductLabel/ProductLabel';
export { default as ProductLabels } from './ProductLabels/ProductLabels';
export { default as ProductLink } from './ProductLink/ProductLink';
export { default as ProductList } from './ProductList/ProductList';
export { default as ProductListSkeleton } from './ProductList/ProductListSkeleton';
export { default as ProductOnboardingCard } from './ProductOnboardingCard/ProductOnboardingCard';
export { default as ProductOnboardingCardSkeleton } from './ProductOnboardingCard/ProductOnboardingCardSkeleton';
export { default as ProductPrice } from './ProductPrice/ProductPrice';
export { default as ProductQuantityEdit } from './ProductQuantityEdit/ProductQuantityEdit';
export { default as ProductsCarousel } from './ProductsCarousel/ProductsCarousel';
export { default as ProductSearchCard } from './ProductSearchCard/ProductSearchCard';
export { default as ProductSearchCardSkeleton } from './ProductSearchCard/ProductSearchCardSkeleton';
export { default as ProductsListingWidget } from './ProductsListingWidget/ProductsListingWidget';
export { default as ProductTag } from './ProductTag/ProductTag';
export { default as ProductThumbnails } from './ProductThumbnails/ProductThumbnails';
export { default as ProductThumbnailsSkeleton } from './ProductThumbnails/ProductThumbnailsSkeleton';

export const SimilarProductsModal = dynamic(() => import('./SimilarProductsModal/SimilarProductsModal'), { ssr: false });
export const ProductQuantityVariantsModal = dynamic(() => import('./ProductQuantityVariantsModal/ProductQuantityVariantsModal'), { ssr: false });
